var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.4223H20V4.61941C20 3.22343 18.8684 2.0918 17.4724 2.0918H2.52762C1.13163 2.0918 0 3.22343 0 4.61941V10.4223ZM1.17187 9.25043V4.61941C1.17187 3.87064 1.77884 3.26367 2.52762 3.26367H17.4724C18.2212 3.26367 18.8281 3.87064 18.8281 4.61941V9.25043H1.17187Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38281 9.83637H3.55469V8.09641H16.4453V9.83637H17.6172V6.92453H2.38281V9.83637Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3438 4.42961H7.65625V5.60148H12.3438V4.42961Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6172 4.42961H16.4453V5.60148H17.6172V4.42961Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17186 14.9204C1.17186 15.8899 1.95776 16.6757 2.92713 16.6757C3.89656 16.6757 4.68241 15.8898 4.68241 14.9204V11.6146H3.51053V14.9204C3.51053 15.2426 3.24935 15.5038 2.92713 15.5038C2.60494 15.5038 2.34374 15.2426 2.34374 14.9204V14.3345H1.17186V14.9204Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41552 17.0663V11.6146H8.24365V17.0663H9.41552Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0746 15.5038C16.7523 15.5038 16.4912 15.2426 16.4912 14.9204V11.6146H15.3193V14.9204C15.3193 15.8898 16.1051 16.6757 17.0746 16.6757C18.0439 16.6757 18.8298 15.8899 18.8298 14.9204V14.3345H17.658V14.9204C17.658 15.2426 17.3968 15.5038 17.0746 15.5038Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0671 17.7559C14.5404 17.7559 14.1135 17.3289 14.1135 16.8022V14.4712H12.9416V16.8022C12.9416 17.9761 13.8932 18.9277 15.0671 18.9277H15.653V17.7559H15.0671Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34783 18.9277H4.93377C6.10764 18.9277 7.05927 17.9761 7.05927 16.8022V14.4712H5.8874V16.8022C5.8874 17.3289 5.46043 17.7559 4.93377 17.7559H4.34783V18.9277Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7578 15.8944V11.6146H10.5859V15.8944H11.7578Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.8235be847822b731abf2423868c7d38e.svg";
export { ForwardRef as ReactComponent };